"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var form_header_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/form_header"));
var constants_1 = require("@hikakaku/shared/constants");
var DEFAULT_TITLE = "\u6700\u5927".concat(constants_1.MAX_ESTIMATE_REQUEST_SIZE, "\u793E\u304B\u3089\u4E00\u62EC\u67FB\u5B9A");
var DEFAULT_DESCRIPTION = '査定価格に納得しない場合は買取依頼しなくてもOK';
var FormHeaderStore = /** @class */ (function () {
    function FormHeaderStore(props) {
        this.component = form_header_1.default;
        this.title = props.title || DEFAULT_TITLE;
        this.description = props.description || DEFAULT_DESCRIPTION;
    }
    return FormHeaderStore;
}());
exports.default = FormHeaderStore;
